import { Dispatch, SetStateAction } from "react";
import { IAdminDocument } from "../../../../../@types/documentAdmnstration.types";
import CreateFolderButton from "./createFolderButton/CreateFolderButton";
import SortButton from "./sortButton/SortButton";
import UploadButton from "./uploadButton/UploadButton";

const ButtonList = ({
	parent_folder_id,
	root_folder_id,
	documentList,
	handleOpen,
	setDocumentList
}: {
	handleOpen: () => void;
	handleChangeSetFile: (file: File) => void;
	documentList: IAdminDocument[];
	setDocumentList: Dispatch<SetStateAction<IAdminDocument[]>>;
	parent_folder_id: string;
	root_folder_id: string;
}) => {
	return (
		<div className="button-list">
			<UploadButton handleOpen={handleOpen} />
			<CreateFolderButton
				documentList={documentList}
				setDocumentList={setDocumentList}
				parent_folder_id={parent_folder_id}
				root_folder_id={root_folder_id}
			/>
		</div>
	);
};

export default ButtonList;
